"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _fiber = require("@react-three/fiber");
var _drei = require("@react-three/drei");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _View3dModule = _interopRequireDefault(require("../../styles/components/View3d.module.css"));
var _CameraControls = _interopRequireDefault(require("./CameraControls"));
var _selectors = require("../../redux/selectors");
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Scene = props => {
  const {
    children: childrenProp,
    canvasClassName
  } = props;
  const children = (0, _react.useDeferredValue)(childrenProp);
  const cameraMoving = (0, _react.useRef)(false);
  const cameraSettings = {
    position: [28, 11, -16],
    near: 0.1,
    far: 5000,
    fov: 25
  };
  const theme = (0, _reactRedux.useSelector)(_selectors.getPackageTheme);
  (0, _react.useEffect)(() => {
    cameraMoving.current = true;
  }, []);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_fiber.Canvas, {
    flat: true,
    gl: {
      logarithmicDepthBuffer: true,
      antialias: false,
      powerPreference: 'low-power'
    },
    onPointerDown: () => cameraMoving.current = false,
    onWheel: () => cameraMoving.current = false
    // ref={canvas}
    ,
    orthographic: true,
    shadows: true
    // performance={{ min: 30 }}
    // raycaster={{ params: { Line: { threshold: 0.15 } } }}
    ,
    camera: cameraSettings,
    className: "".concat(_View3dModule.default.view3d, " ").concat(canvasClassName)
    // dpr={[1, 2]}
  }, /*#__PURE__*/_react.default.createElement(_CameraControls.default, {
    cameraMoving: cameraMoving
  }), /*#__PURE__*/_react.default.createElement(_drei.Plane, {
    receiveShadow: true,
    color: "#b3babc",
    rotation: [-Math.PI / 2, 0, 0],
    position: [0, 0, 0],
    args: [5500, 5500]
    // side={THREE.DoubleSide}
  }, /*#__PURE__*/_react.default.createElement("meshPhongMaterial", {
    receiveShadow: true,
    attach: "material",
    color: _constants.themeSettings[theme].planeColor
  })), children), [cameraSettings, children, cameraMoving, theme]);
};
var _default = exports.default = Scene;